import type { FC } from 'react';
import { Button, Flex, Select, Typography } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import type {
  DashboardPeriod,
  DashboardPeriodOption,
} from '~/app/hooks/dashboard/useDashboardPeriodOptions';

const { Title, Text } = Typography;

export interface ServiceQualityPageHeaderProps {
  title: string;
  subtitle: string;
  period: DashboardPeriod;
  periodOptions: DashboardPeriodOption[];
  periodAriaLabel: string;
  generateReportLabel: string;
  onPeriodChange: (period: DashboardPeriod) => void;
  onGenerateReport: () => void;
}

export const ServiceQualityPageHeader: FC<ServiceQualityPageHeaderProps> = ({
  title,
  subtitle,
  period,
  periodOptions,
  periodAriaLabel,
  generateReportLabel,
  onPeriodChange,
  onGenerateReport,
}) => {
  return (
    <Flex
      justify="space-between"
      align="flex-start"
      gap={16}
      wrap="wrap"
      className="om-dashboard-header"
    >
      <div>
        <Title level={3} className="ds-page-title" style={{ margin: 0 }}>
          {title}
        </Title>
        <Text type="secondary" className="om-dashboard-header__subtitle">
          {subtitle}
        </Text>
      </div>
      <Flex align="center" gap={8} wrap="wrap">
        <Select
          className="om-dashboard-period-select"
          popupClassName="om-dashboard-period-dropdown"
          value={period}
          options={periodOptions}
          onChange={onPeriodChange}
          aria-label={periodAriaLabel}
          popupMatchSelectWidth={false}
        />
        <Button
          type="primary"
          icon={<FileTextOutlined />}
          onClick={onGenerateReport}
        >
          {generateReportLabel}
        </Button>
      </Flex>
    </Flex>
  );
};
